import { themes } from 'kb-shared';
import styled from 'styled-components';

import { Status } from './BubbleStep.types';

type StatusProps = {
  status: Status;
};

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Circle = styled.div<StatusProps>`
  justify-content: center;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 16px;
  color: white;

  ${({ status }) => {
    switch (status) {
      case 'Completed':
        return `background-color: ${themes.colors.yellow.primary};`;
      case 'InProgress':
        return `border: 10px solid ${themes.colors.yellow.primary};`;
      case 'Todo':
        return `border: 10px solid ${themes.colors.yellow.primary};`;
    }
  }}

  svg {
    left: 8px;
    top: 6px;
    height: 16px;
    width: 16px;
    position: relative;
  }
`;

export const Title = styled.div<StatusProps>`
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  background: white;
  color: ${themes.colors.neutral.primaryNavy};
  max-width: 100px;
  word-break: break-word;
  margin-top: 8px;
`;
